const state = {
  userProfile: {},
  features: [],
  services: [],
}
export default state
